'use client';
import { css } from '@wanteddev/wds-engine';
import { respondTo } from '../../utils/index.mjs';

// src/components/dialog/style.ts
var dialogWrapperStyle = (theme) => css`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: ${theme.zIndex.modal};
  width: 100vw;
  height: 100vh;
  left: 0px;
  top: 0px;

  @supports (height: 100dvh) {
    height: 100dvh;
  }
`;
var dialogDimmerStyle = (theme) => css`
  position: fixed;
  inset: 0;
  background-color: ${theme.palette.material.dimmer};
  opacity: ${theme.opacity[43]};
  z-index: -1;
`;
var dialogStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  flex: 1;
`;
var dialogContentStyle = (theme) => css`
  background-color: ${theme.palette.background.elevated.normal};
  border-radius: 12px;
  min-width: 320px;
  max-width: 400px;
  outline: none;

  ${respondTo("360px")} {
    min-width: 100%;
  }
`;
var dialogActionStyle = css`
  padding: 0px 20px 12px 20px;
`;

export { dialogActionStyle, dialogContentStyle, dialogDimmerStyle, dialogStyle, dialogWrapperStyle };
